import productImg from "../images/image-003.jpg";

const companyData = [
  {
    name: "Etno Okami",
    imgUrl: productImg,
    description: `"Ethno Okami" winery is based in the Caucasus
    International University of Viticulture and Winemaking
    on the basis of the faculty and combines both educational and
    production facilities. See the video clip: `,
    video: `https://www.youtube.com/watch?v=T7_txLeeBRI`,
    address: `Tbilisi, Ureki st. N2`,
  },
  
];
export default companyData;
